import React, { FC } from "react";

import TemplateCreate from "../../components/Template/TemplateCreate";

const TemplateCreatePage: FC = () => <TemplateCreate />;

export default TemplateCreatePage;
